<div *ngIf="showDetails" class="app-wrapper" [ngClass]="app?.key">
  <div class="heading-section d-flex justify-content-between align-items-center gap-1 flex-wrap">
    <div class="d-flex align-items-center">
      <h3>{{ app?.name | translate }}</h3>
      <div *ngIf="getAppStatus(app)" class="status-badge ml-4" [ngClass]="getAppStatus(app)">
        <img [src]="'assets/images/'+getAppStatus(app)+'-icon.svg'" *ngIf="app?.status !== AppStatus.ComingSoon">{{
        getAppStatusCopy(app) }}
      </div>
    </div>
    <div class="d-flex align-items-center gap-2">
      <span *ngIf="isShopifyInstalled && (!isMobileVersion || !app?.isInstalled)"
        [ngbTooltip]="'APP.SHOPIFY_UNINSTALL_TOOLTIP' | translate"
        [tooltipClass]="'tooltip-wrapper'">
        <rosie-button [customClass]="customActionClass" [translationKey]="actionTranslationKey"
          class="action-button-wrapper" [disabled]="true"
          [iconPrefixConfig]="{name: actionIconName, size: '20px', strokeWidth: '2', color: actionIconColor}"></rosie-button>
      </span>
      <rosie-button *ngIf="!isShopifyInstalled && (!isMobileVersion || !app?.isInstalled)"
        [customClass]="customActionClass" [translationKey]="actionTranslationKey"
        class="action-button-wrapper"
        [iconPrefixConfig]="{name: actionIconName, size: '20px', strokeWidth: '2', color: actionIconColor}"
        (click)="action()"></rosie-button>
    </div>
  </div>
  <div class="warning-message-wrapper d-flex align-items-center justify-content-between" *ngIf="isShopifyPendingApproval">
    <div class="d-flex align-items-center gap-2">
      <img class="warning-message-icon big" [src]="'assets/images/caution-alert-icon.svg'">
      <span class="warning-message-text">{{ 'ACCOUNT.BILLING.PENDING_APPROVAL_MESSAGE' | translate }}</span>
    </div>
    <rosie-button [customClass]="'btn slim dark'" (click)="openProviderConfirmation()" class="d-block"
      [translationKey]="'ACCOUNT.BILLING.APPROVE_SUBSCRIPTION'"
      [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', color: '#C1BBCA', strokeWidth: '2'}"></rosie-button>
  </div>
  <div class="warning-message-wrapper d-flex align-items-center mb-4" *ngIf="isShopifyUnsupportedForProvider">
    <div class="d-flex align-items-center gap-2">
      <img class="warning-message-icon big" [src]="'assets/images/caution-alert-icon.svg'">
      <span class="warning-message-text">{{ 'APPS.SHOPIFY_NOT_SUPPORTED_PROVIDER' | translate }}</span>
    </div>
  </div>
  <div class="app-separator mb-6"></div>
  <div class="row">
    <div class="col-auto description-section">
      <div class="logo-wrapper position-relative">
        <img [src]="getLogo(app)">
      </div>
      <div *ngIf="app?.statusMessage" class="status-tile d-flex align-items-center p-3 mt-6">
        <img src="assets/images/information-circle.svg" />
        <div>
          <span *ngFor="let msg of app?.statusMessage" [ngClass]="msg.customClass">
            <ng-container *ngIf="msg.url else simpleText">
              <a (click)="navigateTo(msg.url)">{{ msg.title | translate }}</a>&nbsp;
            </ng-container>
            <ng-template #simpleText>{{ msg | translate }}&nbsp;</ng-template>
          </span>
        </div>
      </div>
      <div [innerHTML]="appDescriptionKey | translate:{value: settingUrl}" class="description"></div>
      <div *ngIf="getSupportDocsLink() as supportDocsLink" class="support-docs-link">
        <a [href]="supportDocsLink.value" target="_blank">
          <span class="support-docs-label">{{ supportDocsLink.label }}</span>
          <ng-icon [name]="'heroArrowUpRight'" [size]="'14px'" [strokeWidth]="'2'" [color]="'#7f728a'"
            class="support-docs-arrow"></ng-icon>
        </a>
      </div>
      <div *ngIf="app?.isScheduling && app?.isInstalled" class="scheduling-section">
        <div class="scheduling-tile d-flex align-items-start p-4">
          <div class="calendar-icon-wrapper d-flex align-items-center justify-content-center">
            <ng-icon [name]="'heroCalendarDays'" [size]="'24px'" [strokeWidth]="'2'" [color]="'#822AC6'"></ng-icon>
          </div>
          <div class="scheduling-content">
            <div class="scheduling-message">
              {{ 'APP.SCHEDULING.MESSAGE' | translate }}
            </div>
            <a class="scheduling-link d-inline-flex align-items-center" (click)="navigateToAppointmentSettings()">
              {{ 'APP.SCHEDULING.LINK' | translate }}
              <ng-icon [name]="'heroArrowUpRight'" [size]="'14px'" [strokeWidth]="'2'" [color]="'#822AC6'"
                class="ml-sm"></ng-icon>
            </a>
          </div>
        </div>
      </div>
      <div *ngIf="app?.key === AppKey.Shopify && app?.isInstalled" class="scheduling-section">
        <div class="scheduling-tile d-flex align-items-start p-4">
          <div class="calendar-icon-wrapper d-flex align-items-center justify-content-center">
            <ng-icon [name]="'heroShoppingCart'" [size]="'24px'" [strokeWidth]="'2'" [color]="'#822AC6'"></ng-icon>
          </div>
          <div class="scheduling-content">
            <div class="scheduling-message">
              {{ 'APP.COMMERCE.MESSAGE' | translate }}
            </div>
            <a class="scheduling-link d-inline-flex align-items-center" (click)="navigateToCommerceSettings()">
              {{ 'APP.COMMERCE.LINK' | translate }}
              <ng-icon [name]="'heroArrowUpRight'" [size]="'14px'" [strokeWidth]="'2'" [color]="'#822AC6'"
                class="ml-sm"></ng-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col metadata-section">
      <!-- Orange Warning Box for Unsupported Questions -->
      <div class="warning-message-wrapper mb-5"
        *ngIf="app?.isInstalled && hasSchedulingAppWithEventTypes && hasUnsupportedQuestions">
        <div class="w-100">
          <div class="d-flex align-items-center gap-2">
            <img class="warning-message-icon big" [src]="'assets/images/caution-alert-icon.svg'">
            <div class="warning-message-text title">
              {{ 'APP.UNSUPPORTED_QUESTIONS.TITLE' | translate }}
            </div>
          </div>
          <div class="warning-message-text mt-md">
            {{ 'APP.UNSUPPORTED_QUESTIONS.DESCRIPTION' | translate:{appName: app?.name} }}
          </div>
          <div class="warning-message-text mt-4">
            <span class="bold">{{ 'APP.UNSUPPORTED_QUESTIONS.FIX_TITLE' | translate:{appName: app?.name} }}</span>
          </div>
          <ul class="warning-message-list mb-4">
            <li class="warning-message-text">{{ 'APP.UNSUPPORTED_QUESTIONS.FIX_OPTION_1' | translate }}</li>
            <li class="warning-message-text">{{ 'APP.UNSUPPORTED_QUESTIONS.FIX_OPTION_2' | translate }}</li>
            <li class="warning-message-text">{{ 'APP.UNSUPPORTED_QUESTIONS.FIX_OPTION_3' | translate }}</li>
          </ul>
          <div class="warning-message-text">
            {{ 'APP.UNSUPPORTED_QUESTIONS.NOTE_PREFIX' | translate }}
            <span class="warning-message-link" (click)="synchronize()">{{ 'APP.UNSUPPORTED_QUESTIONS.RESYNC_LINK' |
              translate }}</span>
            {{ 'APP.UNSUPPORTED_QUESTIONS.NOTE_SUFFIX' | translate }}
          </div>
        </div>
      </div>

      <div class="item d-flex flex-column" *ngIf="(app?.hasExternalFlow || (app?.isCrm && app?.hasFormFlow)) && !(app?.key === AppKey.Shopify && app?.isInstalled)">
        <span class="label">{{ 'APP.DETAILS' | translate }}</span>
        <div class="content d-flex align-items-center">
          <div *ngIf="!app?.isInstalled" class="w-100">
            <div [innerHTML]="appDetailsKey | translate" class="details-copy"></div>
            <div *ngIf="planRequirement" class="status-tile plan-requirement d-flex align-items-center p-3 mt-3">
              <ng-icon [name]="'heroInformationCircle'" [size]="'20px'" [strokeWidth]="'2'" [color]="'#6C6176'"
                class="d-block"></ng-icon>
              <div>{{ planRequirement }}</div>
            </div>
            <div *ngIf="temporaryRestriction" class="status-tile plan-requirement d-flex align-items-start p-3 mt-3">
              <ng-icon [name]="'heroInformationCircle'" [size]="'20px'" [strokeWidth]="'2'" [color]="'#6C6176'"
                class="d-block"></ng-icon>
              <div [innerHTML]="temporaryRestriction"></div>
            </div>
          </div>
          <div *ngIf="app?.isInstalled && configEntries.length > 0" class="w-100">
            <!-- Non-event type config entries -->
            <div *ngFor="let configEntry of nonEventTypeConfigEntries; trackBy: trackByKey" class="data-item-wrapper"
              [ngClass]="{'has-multiple-items': isConfigValueArray(configEntry.value) && configEntry.value.length > 1}">
              <div class="app-label d-flex align-items-center">
                {{ getConfigTranslationKey(configEntry.key) | translate }}
                <ng-icon *ngIf="getConfigTooltip(configEntry.key)" [name]="'heroInformationCircle'"
                  class="ml-sm d-block pointer" [ngbTooltip]="getConfigTooltip(configEntry.key)"
                  [tooltipClass]="'tooltip-wrapper'" [color]="'#9487A0'"></ng-icon>
              </div>
              <div class="app-value">
                <ng-container *ngIf="!isConfigValueArray(configEntry.value)">
                  {{ configEntry.value }}
                </ng-container>
                <ng-container *ngIf="isConfigValueArray(configEntry.value)">
                  <div *ngFor="let item of configEntry.value" class="config-array-item">
                    {{ formatConfigArrayItem(item) }}
                  </div>
                </ng-container>
              </div>
            </div>

            <ng-container *ngIf="app?.isCrm">
              <div class="data-item-wrapper has-multiple-items crm-detail-row">
                <div class="app-label d-flex align-items-center">
                  {{ 'APP.CRM.LEAD_FILTERS.LABEL' | translate }}
                  <ng-icon [name]="'heroInformationCircle'" class="ml-sm d-block pointer"
                    [ngbTooltip]="'APP.CRM.LEAD_FILTERS.TOOLTIP' | translate:{appName: app?.name}"
                    [tooltipClass]="'tooltip-wrapper'" [color]="'#9487A0'"></ng-icon>
                </div>
                <div class="app-value crm-detail-values d-flex flex-column align-items-end">
                  <div *ngFor="let filter of activeCrmFilters">{{ filter.labelKey | translate }}</div>
                  <div *ngIf="activeCrmFilters.length === 0">{{ 'APP.CRM.LEAD_FILTERS.NONE' | translate }}</div>
                </div>
              </div>
              <ng-container *ngIf="hasCrmRequiredFields">
                <div class="data-item-wrapper has-multiple-items crm-detail-row">
                  <div class="app-label d-flex align-items-center">
                    {{ crmRequiredFieldsLabel }}
                    <ng-icon [name]="'heroInformationCircle'" class="ml-sm d-block pointer"
                      [ngbTooltip]="crmRequiredFieldsTooltipKey | translate:{appName: app?.name}"
                      [tooltipClass]="'tooltip-wrapper'" [color]="'#9487A0'"></ng-icon>
                  </div>
                  <div class="app-value crm-detail-values d-flex flex-column align-items-end">
                    <div *ngFor="let field of crmRequiredFields" class="crm-required-field d-flex align-items-center">
                      <div>{{ field.label }}</div>
                      <div class="crm-field-tag d-inline-flex align-items-center" [ngClass]="field.status">
                        <ng-icon *ngIf="field.status === CrmRequiredFieldStatus.Unavailable"
                          [name]="'heroExclamationTriangle'" [size]="'12px'" [strokeWidth]="'2.4'"
                          [color]="'#C2410C'"></ng-icon>
                        {{ getCrmRequiredFieldStatusKey(field.status) | translate }}
                      </div>
                    </div>
                    <div *ngIf="crmRequiredFields.length === 0">{{ crmRequiredFieldsEmptyKey | translate }}</div>
                  </div>
                </div>
                <div class="warning-message-wrapper small" role="alert" *ngIf="crmBlockingFieldLabels.length > 0">
                  <img class="warning-message-icon" [src]="'assets/images/caution-alert-icon.svg'">
                  <div class="warning-message-text">
                    {{ (crmBlockingFieldLabels.length === 1 ? 'APP.CRM.REQUIRED_FIELDS.UNAVAILABLE_WARNING_ONE' :
                    'APP.CRM.REQUIRED_FIELDS.UNAVAILABLE_WARNING_MANY') | translate:{appName: app?.name, fields:
                    crmBlockingFieldLabels.join(', ')} }}
                  </div>
                </div>
                <div class="warning-message-wrapper small" role="alert" *ngIf="hasCrmRequiredFieldsSyncFailed">
                  <img class="warning-message-icon" [src]="'assets/images/caution-alert-icon.svg'">
                  <div class="warning-message-text">
                    <ng-container *ngIf="app?.hasExternalFlow">
                      {{ 'APP.CRM.REQUIRED_FIELDS.SYNC_FAILED_OAUTH' | translate:{appName: app?.name} }}
                      <span class="warning-message-link" (click)="reconnect()">{{
                        'APP.CRM.REQUIRED_FIELDS.RECONNECT' | translate:{appName: app?.name} }}</span>
                    </ng-container>
                    <ng-container *ngIf="!app?.hasExternalFlow">
                      {{ 'APP.CRM.REQUIRED_FIELDS.SYNC_FAILED' | translate:{appName: app?.name} }}
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <!-- Event Types with Expandable Questions -->
            <div class="event-types-section" *ngIf="hasSchedulingAppWithEventTypes">
              <div class="data-item-wrapper event-types-header d-block">
                <div class="app-label d-flex align-items-center mb-md">
                  {{ 'APP.CONFIG.CONNECTED_EVENT_TYPES' | translate }}
                  <ng-icon [name]="'heroInformationCircle'" class="ml-sm d-block pointer"
                    [ngbTooltip]="getConfigTooltip('eventTypes')" [tooltipClass]="'tooltip-wrapper'"
                    [color]="'#9487A0'"></ng-icon>
                </div>
                <div class="event-type-item" *ngFor="let eventType of eventTypes">
                  <div class="event-type-row" [class.clickable]="getEventTypeQuestionsCount(eventType) > 0 || hasEventTypeUnsupportedFields(eventType)"
                    (click)="(getEventTypeQuestionsCount(eventType) > 0 || hasEventTypeUnsupportedFields(eventType)) && toggleEventTypeExpansion(eventType)">
                    <div class="event-type-name">{{ eventType.name }}</div>
                    <div class="event-type-status d-flex align-items-center">
                      <ng-container *ngIf="hasEventTypeUnsupportedFields(eventType)">
                        <div class="d-flex align-items-center" [hidden]="isEventTypeExpanded(eventType)">
                          <img [src]="'assets/images/exclamation-orange.svg'">
                          <div class="unsupported-status">
                            {{ 'APP.EVENT_TYPES.UNSUPPORTED_SETTINGS' | translate }}</div>
                        </div>
                        <ng-icon [name]="isEventTypeExpanded(eventType) ? 'heroChevronUp' : 'heroChevronDown'"
                          [size]="'14px'" [strokeWidth]="'2'" [color]="'#9487A0'" class="expand-icon"></ng-icon>
                      </ng-container>
                      <ng-container *ngIf="!hasEventTypeUnsupportedFields(eventType) && getEventTypeQuestionsCount(eventType) === 0">
                        <div class="supported-status">{{ 'APP.EVENT_TYPES.NO_QUESTIONS' | translate }}</div>
                      </ng-container>
                      <ng-container *ngIf="!hasEventTypeUnsupportedFields(eventType) && getEventTypeQuestionsCount(eventType) > 0">
                        <ng-container *ngIf="hasEventTypeUnsupportedQuestions(eventType)">
                          <div class="d-flex align-items-center" [hidden]="isEventTypeExpanded(eventType)">
                            <img [src]="'assets/images/exclamation-orange.svg'">
                            <div class="unsupported-status">
                              {{ 'APP.EVENT_TYPES.UNSUPPORTED_QUESTIONS' | translate
                              }}</div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="!hasEventTypeUnsupportedQuestions(eventType)">
                          <div class="d-flex align-items-center" [hidden]="isEventTypeExpanded(eventType)">
                            <img [src]="'assets/images/checkmark-grey.svg'">
                            <div class="supported-status">{{
                              getEventTypeQuestionsCount(eventType) }} {{
                              (getEventTypeQuestionsCount(eventType) === 1 ? 'APP.EVENT_TYPES.QUESTION' :
                              'APP.EVENT_TYPES.QUESTIONS') | translate }}</div>
                          </div>
                        </ng-container>
                        <ng-icon [name]="isEventTypeExpanded(eventType) ? 'heroChevronUp' : 'heroChevronDown'"
                          [size]="'14px'" [strokeWidth]="'2'" [color]="'#9487A0'" class="expand-icon"></ng-icon>
                      </ng-container>
                    </div>
                  </div>
                  <div class="event-type-questions"
                    *ngIf="isEventTypeExpanded(eventType) && (getEventTypeQuestionsCount(eventType) > 0 || hasEventTypeUnsupportedFields(eventType))">
                    <div class="question-item invalid" *ngFor="let field of getEventTypeUnsupportedFields(eventType)">
                      <img [src]="'assets/images/exclamation-orange.svg'">
                      <span class="question-text">{{ field.reason }}</span>
                    </div>

                    <div class="warning-message-wrapper small" *ngIf="hasEventTypeUnsupportedFields(eventType)">
                      <img class="warning-message-icon" [src]="'assets/images/caution-alert-icon.svg'">
                      <div class="warning-message-text">
                        This event type has settings that are incompatible with Rosie. Please update them in your calendar provider.
                      </div>
                    </div>

                    <div class="question-item" *ngFor="let question of getEventTypeQuestions(eventType)"
                      [ngClass]="{'invalid': !isQuestionValid(question)}">
                      <img *ngIf="!isQuestionValid(question)" [src]="'assets/images/exclamation-orange.svg'">
                      <img *ngIf="isQuestionValid(question)" [src]="'assets/images/checkmark-grey.svg'">
                      <span class="question-text">{{ question.question }}</span>
                    </div>

                    <div class="warning-message-wrapper small" *ngIf="hasEventTypeUnsupportedQuestions(eventType)">
                      <img class="warning-message-icon" [src]="'assets/images/caution-alert-icon.svg'">
                      <div class="warning-message-text">
                        Only <span>text</span> and <span>paragraph fields</span> are
                        compatible.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="data-item-wrapper" *ngIf="(app?.hasExternalFlow && !app?.isCrm) || app?.key === AppKey.AgencyZoom || hasCrmRequiredFields">
              <div class="app-label d-flex align-items-center">
                {{ 'APP.RESYNC.LABEL' | translate:{appName: app?.name} }}
                <ng-icon [name]="'heroInformationCircle'" class="ml-sm d-block pointer"
                  [ngbTooltip]="getResyncTooltip()" [tooltipClass]="'tooltip-wrapper'" [color]="'#9487A0'"></ng-icon>
              </div>
              <div class="app-value">
                <rosie-button (click)="synchronize()" [customClass]="'secondary slimmish narrow text-sm'"
                  [spinnerColor]="{outer: '#f3f2f5', inner: '#6C6176'}"
                  [iconPrefixConfig]="{name: 'heroArrowPath', size: '16px', strokeWidth: '2', color: '#6C6176'}"
                  [translationKey]="'APP.RESYNC.BUTTON'" [inProgress]="isSyncInProgress">
                </rosie-button>
              </div>
            </div>
          </div>
          <div *ngIf="app?.isInstalled && configEntries.length === 0" [innerHTML]="appDetailsKey | translate">
          </div>
        </div>
      </div>

      <div class="item d-flex flex-column" *ngIf="app?.key === AppKey.Yelp">
        <span class="label">{{ 'APP.YELP.SETUP.LABEL' | translate }}</span>
        <rosie-yelp-zapier-setup *ngIf="app?.isInstalled" [app]="app"
          (setupCompleteChange)="isYelpSetupComplete = $event"></rosie-yelp-zapier-setup>
        <rosie-yelp-zapier-setup *ngIf="!app?.isInstalled" [app]="app" [preview]="true"></rosie-yelp-zapier-setup>
      </div>
    </div>
  </div>
  <div class="d-flex gap-2 mt-3 flex-wrap" *ngIf="isMobileVersion && app?.isInstalled">
    <span *ngIf="isShopifyInstalled" [ngbTooltip]="'APP.SHOPIFY_UNINSTALL_TOOLTIP' | translate"
      [tooltipClass]="'tooltip-wrapper'">
      <rosie-button [customClass]="customActionClass" [translationKey]="actionTranslationKey"
        [fullWidth]="false" [disabled]="true"
        [iconPrefixConfig]="{name: actionIconName, size: '20px', strokeWidth: '2', color: actionIconColor}"></rosie-button>
    </span>
    <rosie-button *ngIf="!isShopifyInstalled" [customClass]="customActionClass" [translationKey]="actionTranslationKey"
      [fullWidth]="false"
      [iconPrefixConfig]="{name: actionIconName, size: '20px', strokeWidth: '2', color: actionIconColor}"
      (click)="action()"></rosie-button>
  </div>
</div>
<ngx-smart-modal #settingsModal disableRefocus (onAnyCloseEventFinished)="handleSettingsModalClose()" [closable]="true"
  identifier="{{AppModalEnum.Settings}}" disableRefocus>
  <rosie-app-settings (install)="install()" (update)="update()" (verify)="verify()" [app]="app"
    [modalClosed]="settingsModalClosedSubject">
  </rosie-app-settings>
</ngx-smart-modal>
<ngx-smart-modal #updateModal disableRefocus [closable]="true" [customClass]="'install-update-modal'"
  identifier="{{AppModalEnum.Update}}" disableRefocus>
  <rosie-app-update (install)="install(true)" (updateAppProfile)="updateAppProfile($event)" [app]="app" [form]="form">
    <ng-content></ng-content>
  </rosie-app-update>
</ngx-smart-modal>
<ngx-smart-modal #installModal disableRefocus [closable]="true" (onOpen)="initCredentialsFlow()"
  [customClass]="'install-update-modal'" (onAnyCloseEvent)="closeInstallModal()" identifier="{{AppModalEnum.Install}}"
  disableRefocus>
  <rosie-app-install (install)="install()" (next)="nextInstallStep()" (back)="previousInstallStep()" [step]="installStep"
    [app]="app" [form]="form">
    <ng-container *ngIf="app?.hasCredentialsFlow">
      <div *ngFor=" let field of app?.setupData?.formFields; let last=last; let first=first"
        [ngClass]="{'mb-2': !last, 'mt-5': first}">
        <rosie-field-value-copy [labelKey]="'Api Key'" [value]="field.value" *ngIf="field.value"
          [showShimmer]="!field.value"></rosie-field-value-copy>
      </div>
      <div class="d-flex mt-5 gap-2">
        <rosie-button (click)="close()" [customClass]="'secondary d-block'" [translationKey]="'COMMON.CANCEL'"
          class="d-block btn-install">
        </rosie-button>
        <rosie-button (click)="verify()" [fullWidth]="true" [inProgress]="app?.inProgress"
          [translationKey]="'APP.VERIFY'" class="d-block btn-install">
        </rosie-button>
      </div>
    </ng-container>
    <ng-content></ng-content>
  </rosie-app-install>
</ngx-smart-modal>
<ngx-smart-modal #uninstallModal disableRefocus [closable]="true" identifier="{{AppModalEnum.Uninstall}}"
  disableRefocus>
  <rosie-app-uninstall (uninstall)="uninstall()" [app]="app"></rosie-app-uninstall>
</ngx-smart-modal>
<ngx-smart-modal #calendarConflictModal disableRefocus [closable]="true" identifier="{{AppModalEnum.CalendarConflict}}"
  [customClass]="'app-conflict-modal'" disableRefocus>
  <rosie-app-calendar-conflict (continueInstall)="proceedWithCalendarInstall()" [app]="app"
    [conflictingApp]="conflictingCalendarApp"></rosie-app-calendar-conflict>
</ngx-smart-modal>
<ng-template #form let-form="form" let-formFields="formFields" let-formOptions="formOptions">
  <div *ngFor="let field of form?.controls | keyvalue: unsorted; let last = last; let first = first;"
    [hidden]="formOptions?.[field.key]?.hidden" [ngClass]="{'mt-3': isFirstVisibleField(form, formOptions, field.key)}"
    class="{{ formOptions?.[field.key]?.customClass || 'mb-2' }}">
    <div *ngIf="getFieldType(formFields, field.key) !== AppFieldType.Array">
      <ng-container
        [ngTemplateOutletContext]="{ form: form, field: field, type: getFieldType(formFields, field.key), options: formOptions?.[field.key] }"
        [ngTemplateOutlet]="formField">
      </ng-container>
    </div>

    <div *ngIf="getFieldType(formFields, field.key) === AppFieldType.Array">
      <div class="array-form-wrapper">
        <rosie-alert *ngIf="formOptions?.[field.key]?.description"
          [customClass]="'status-tile d-flex align-items-center p-3 mb-2'"
          [innerHtml]="formOptions?.[field.key]?.description.message | translate" [type]="'info'"></rosie-alert>
        <div
          *ngFor="let arrayField of form.get(field.key)?.controls | keyvalue: unsorted; let i = index; let first = first;"
          class="mb-2 position-relative">
          <ng-container
            [ngTemplateOutletContext]="{ form: form?.get(field.key), field: arrayField, type: getFieldArrayType(formFields, field.key) }"
            [ngTemplateOutlet]="formField">
          </ng-container>
          <div (click)="removeFormField(field.key, i)" *ngIf="!first && formOptions?.[field.key]?.actionRemove"
            class="remove-field" title="{{ formOptions?.[field.key]?.actionRemove.message | translate }}">
            <div class="remove-field-icon-wrapper">
              <span class="remove-field-icon"></span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="formOptions?.[field.key]?.actionAdd" class="add-field">
        <a (click)="addFormField(field.key)" class="link">{{
          formOptions?.[field.key]?.actionAdd?.message |
          translate
          }}</a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #formField let-field="field" let-form="form" let-options="options" let-type="type">
  <rosie-alert *ngIf="options?.description" [customClass]="'status-tile d-flex align-items-center p-3 mb-1'"
    [innerHtml]="options?.description.message | translate" [type]="'info'"></rosie-alert>
  <div [hidden]="options?.hidden" [ngSwitch]="type">
    <div *ngSwitchCase="AppFieldType.Text">
      <rosie-text *ngIf="!app?.isFieldReadOnly(field.key)" [control]="form?.get(field.key)"
        [labelTranslationKey]="getFieldTranslation(field.value?.['fieldName'] || field.key)"
        [tooltip]="getFieldAdditionalInformation(field.key)"></rosie-text>
      <rosie-field-value-copy
        *ngIf="app?.isFieldReadOnly(field.key) && app?.hasFieldAction(field.key, AppFormFieldActionEnum.Copy)"
        [customClass]="'status-tile mb-1 p-3'" [labelKey]="getFieldTranslation(field.value?.['fieldName'] || field.key)"
        [value]="form?.get(field.key)?.value"></rosie-field-value-copy>
    </div>
    <div *ngSwitchCase="AppFieldType.Select">
      <rosie-select-input *ngIf="getFieldDisplayType(field.key) === AppFieldDisplayType.Default"
        [appendTo]="'body'" [control]="form?.get(field.key)"
        [customClass]="'select-full-arrow-sm'" [dataHook]="form?.get(field.key)"
        [options]="app.getFieldSelectOptions(field.value?.['fieldName'] || field.key)"
        [placeholderTranslationKey]="getSelectPlaceholder(field.key)">
      </rosie-select-input>
      <div *ngIf="getFieldDisplayType(field.key) === AppFieldDisplayType.Options">
        <div class="text-edit-wrapper-label text-uppercase">
          {{ getFieldAdditionalInformation(field.key) }}
        </div>
        <div class="radio-group-field">
          <rosie-radio-group (valueChanged)="handleFieldSelectOptionChanged(field.key, $event)"
            [control]="form?.get(field.key)" [dataHook]="form?.get(field.key)"
            [options]="app.getFieldSelectOptions(field.value?.['fieldName'] || field.key)"
            [title]="getFieldTranslation(field.key)"></rosie-radio-group>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="AppFieldType.Boolean">
      <div class="boolean-field">
        <div class="title-text-switch-wrapper">
          <div>
            <div class="title text-primary pr-2">{{
              getFieldTranslation(field.value?.['fieldName'] ||
              field.key)
              }}
            </div>
          </div>
          <rosie-switch [ariaLabel]="getFieldTranslation(field.value?.['fieldName'] || field.key)" [control]="form?.get(field.key)" [dataHook]="field?.key + '-toggle'" class="d-flex">
          </rosie-switch>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="AppFieldType.File">
      <rosie-file-field (fileUploaded)="handleFileUpload($event)" [control]="form?.get(field.key)"
        [customClass]="!!form?.get(field.key)?.errors?.['incorrect'] ? 'has-errors' : ''"
        [fieldData]="getFileFieldData(field.key)" [isEditable]="isFieldEditable(field.key)"
        [tooltip]="getFieldAdditionalInformation(field.key)">
      </rosie-file-field>
    </div>

    <rosie-validation-error [show]="form?.get(field.key)?.invalid && form?.get(field.key)?.touched"
      [translationAttributes]="{value: getFieldTranslation(field.value?.['fieldName'] || field.key)}"
      [translationKey]="getFieldValidationErrorTranslation(field.key)">
    </rosie-validation-error>
    <div *ngIf="getHelpTextPerField(field.value?.['fieldName'] || field.key) && !(form?.get(field.key)?.invalid && form?.get(field.key)?.touched)"
      class="text-secondary mt-1">
      {{ getHelpTextPerField(field.value?.['fieldName'] || field.key) }}
    </div>
  </div>
</ng-template>